import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'

export default class ConfirmModal extends Component {

  constructor() {
    super()
    this.state = { show: false }
  }

  show(confirm) {
    this.setState({ show: true, confirm: confirm })
  }

  onCancel() {
    this.setState({ show: false })
  }

  onConfirm() {
    this.state.confirm()
    this.setState({ show: false })
  }

  render() {
    return (
      <div>
        <Modal show={ this.state.show } onHide={ () => this.onCancel() }>
          <Modal.Header>
            <Modal.Title>Bevestiging</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <span>{ this.props.message }</span>
          </Modal.Body>

          <Modal.Footer>
            <Button bsStyle='danger' onClick={ () => this.onCancel() } id='cancel'>Nee</Button>
            <Button bsStyle='success' onClick={ () => this.onConfirm() } id='confirm'>Ja</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
